import { variables } from '@bitrise/bitkit';
import { VizContext } from '@bitrise/bitviz';
import React, { FunctionComponent, useContext } from 'react';
import { motion } from 'framer-motion';

export interface MinMaxPoint {
  avg: number | null;
  max: number | null;
  min: number | null;
  x: number;
}

const MinAvgMaxDataPoint: FunctionComponent<MinMaxPoint> = (props) => {
  const { avg, max, min, x, ...rest } = props;

  const { getX, getY, transition, yDomain } = useContext(VizContext);

  const yAvg = getY(avg || yDomain[0]) as number;
  const yMax = (getY(max) || yAvg) as number;
  const yMin = (getY(min) || yAvg) as number;
  const px = getX(x) as number;

  return (
    <motion.g {...rest} style={{ pointerEvents: 'none' }} transition={transition}>
      <motion.line
        animate={{
          x1: px,
          x2: px,
          y1: yMin,
          y2: yMax,
        }}
        initial={{
          x1: px,
          x2: px,
          y1: yMin,
          y2: yMax,
        }}
        stroke={variables.colorGray5}
        strokeWidth="1"
        transition={transition}
      />

      <motion.line
        animate={{
          x1: px - 5,
          x2: px + 5,
          y1: yMax,
          y2: yMax,
        }}
        initial={{
          x1: px,
          x2: px,
          y1: yMax,
          y2: yMax,
        }}
        stroke={variables.colorGrape5}
        strokeWidth="1"
        transition={transition}
      />

      <motion.line
        animate={{
          x1: px - 5,
          x2: px + 5,
          y1: yMin,
          y2: yMin,
        }}
        initial={{
          x1: px,
          x2: px,
          y1: yMin,
          y2: yMin,
        }}
        stroke={variables.colorGrape5}
        strokeWidth="1"
        transition={transition}
      />

      <motion.g animate={{ x: px, y: yAvg }} initial={{ x: px, y: yAvg }} transition={transition}>
        <polygon fill={variables.colorGrape5} points="0,-6 6,0 0,6 -6,0" />
      </motion.g>
    </motion.g>
  );
};

export default MinAvgMaxDataPoint;
